import React, { useEffect, useRef } from "react";
import { AppliedFilterInterface, FilterInterface, Filters as ShopifyFilters } from "@shopify/polaris";
import "./Filters.scss";
import { notNull } from "@utils/typeUtils";
import { Filter } from "react-feather";
import { Flex } from "@core";

export type FilterItem = FilterInterface &
  AppliedFilterInterface & {
    clearAll: () => void;
    appliedFilter?: AppliedFilterInterface | null;
  };

export default function Filters({ filters, showIcon }: { filters: FilterItem[]; showIcon: boolean }) {
  const filterRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const clearAll = filterRef.current?.querySelector(".Polaris-Filters__ClearAll");

    if (clearAll) {
      clearAll.innerHTML = "";
    }
  }, []);

  const appliedFilters = filters.map(f => (f.appliedFilter === undefined ? f : f.appliedFilter)).filter(notNull);

  return (
    <div className="filters" ref={filterRef}>
      {filters.length > 0 && (
        <Flex left row center>
          {showIcon && <Filter fill="#OOOOOO" size={16} />}
          <ShopifyFilters
            filters={filters}
            onClearAll={() => filters.filter(f => f.clearAll).forEach(f => f.clearAll())}
            onQueryChange={() => null}
            onQueryClear={() => null}
            hideQueryField
            appliedFilters={appliedFilters}
          />
        </Flex>
      )}
    </div>
  );
}
